import React, {useState, useEffect} from 'react'

export default function Calculator() {

    const [totalCash, setTotalCash] = useState("");
    const [remainingCash, setRemainingCash] = useState(0);
    const [totalDue, setTotalDue] = useState(0);
    const [change, setChange] = useState(0);
    const [total, setTotal] = useState(0);

    // Function to load due amount from event detail
    const loadDueAmount = (detail) => {
        setTotal(detail.total);
        setTotalDue(detail.total);
        setRemainingCash(detail.total);

        // Hide loader for calculator (if applicable)
        console.log('HideLoader called');
    };

    // Function to calculate amount based on input value
    const calculateAmount = (value) => {
        const valueString = String(value);
    
        if (valueString === '.' && totalCash.includes('.')) {
            return;
        }
    
        if (totalCash.includes('.') && valueString !== '.') {
            const decimalPart = totalCash.split('.')[1];
    
            if (decimalPart.length >= 2) {
                return;
            }
        }
    
        let updatedTotalCash;
    
        if (valueString === '.' && totalCash === '') {
            updatedTotalCash = '0.';
        } else {
            updatedTotalCash = totalCash + valueString;
        }
    
        setTotalCash(updatedTotalCash);
    
        const numericCash = parseFloat(updatedTotalCash);
    
        if (!isNaN(numericCash)) {
            calculateDueAmount(numericCash);
        }
    };

    // Function to add a specific amount
    const addAmount = (amount) => {
        const updatedTotalCash =
            (parseFloat(totalCash) || 0) + parseFloat(amount);
    
        setTotalCash(updatedTotalCash.toFixed(2));
        calculateDueAmount(updatedTotalCash);
    };

    // Function to calculate due amount
    const calculateDueAmount = (updatedTotalCash) => {
        const due = parseFloat(totalDue) || 0;
        const cash = parseFloat(updatedTotalCash) || 0;
    
        const cashDue = due - cash;
    
        if (cashDue > 0) {
            setRemainingCash(cashDue.toFixed(2));
            setChange(0);
        } else {
            setRemainingCash(0);
    
            const calculatedChange = cash - due;
            setChange(calculatedChange.toFixed(2));
        }
    };

    // Function to clear all values
    const clear = () => {
        setTotalCash('');
        setChange(0);
        setRemainingCash(total);
    };
    // Listen for the 'total-due-amount' event to load due amount
    useEffect(() => {
        const handleTotalDueEvent = (event) => {
            loadDueAmount(event.detail);
        };
        window.addEventListener('total-due-amount', handleTotalDueEvent);
        return () => {
            window.removeEventListener('total-due-amount', handleTotalDueEvent);
        };
    }, []);

  return (
    <div className="cashPaymentCol pb-2">
        <hr/>
        <div className="d-flex flex-column gap-2 mb-3">
            <div className="sbRow flex-nowrap">
                <span className="lbl">Total Cash</span>
                <span className="val">$ {totalCash}</span>
            </div>
            <div className="sbRow flex-nowrap">
                <span className="lbl">Remaining</span>
                <span className="val">$ {remainingCash}</span>
            </div>
            <div className="sbRow flex-nowrap">
                <span className="lbl">Total Due</span>
                <span className="val">$ {totalDue}</span>
            </div>
            <div className="sbRow flex-nowrap">
                <span className="lbl">Change</span>
                <span className="val">$ {change}</span>
            </div>
        </div>
        <div className="row g-0 cashCalculator">
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => calculateAmount(1)}>1</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => calculateAmount(2)}>2</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => calculateAmount(3)}>3</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => addAmount(10)}>10+</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => calculateAmount(4)}>4</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => calculateAmount(5)}>5</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => calculateAmount(6)}>6</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => addAmount(20)}>20+</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => calculateAmount(7)}>7</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => calculateAmount(8)}>8</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => calculateAmount(9)}>9</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => addAmount(50)}>50+</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => calculateAmount('.')}>.</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => calculateAmount(0)}>0</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => clear()}>CE</button></div>
            <div className="col-3 ccCol"><button type="button" className="btn cashCalBtn" onClick={() => addAmount(100)}>100+</button></div>
        </div>
    </div>
  )
}
